var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',{staticClass:"main-loginPage",staticStyle:{"background":"url('https://www.hispatectrack.com/wp-content/uploads/slider.jpg') no-repeat center center","background-size":"cover"},attrs:{"login-screen":""}},[_c('ResetPassword',{attrs:{"has-restore-pass":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }